import {Font, StyleSheet, Text, View} from '@react-pdf/renderer'
import React from 'react'

const styles = StyleSheet.create({
	item: {
		flexDirection: 'row',
		margin: 12
	},
	bulletPoint: {
		width: 10,
		fontSize: 14,
	},
	itemContent: {
		flex: 1,
		fontSize: 10,
		fontFamily: 'Roboto',
	}
})

Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
	]
});

export const List = ({ children }) => children;

export const ListItem = ({ children }) => (
	<View style={styles.item}>
		<Text style={styles.bulletPoint}>•</Text>
		<Text style={styles.itemContent}>{children}</Text>
	</View>
);



// WEBPACK FOOTER //
// ./src/react/ui/PDFCreation/Components/BulletPiontList.js